import { HttpClient } from '@/shared/lib/http-client';

export const fetchMainBanner = async () => {
  const response = await HttpClient.post('/banners/getOnMain');

  return response.data?.data;
};
